// question-adapter.ts - Adapter to convert QuestionData to format expected by existing UI

export class QuestionAdapter {
  constructor(questionData) {
    this.questionData = questionData;
  }

  // Convert QuestionData to format expected by existing UI
  toUIFormat() {
    if (!this.questionData) return null;

    const adapted = {
      // ID fields
      id: this.questionData.id,
      questionNumber: this.questionData.questionNumber,
      diagramId: this.questionData.diagramId,
      displayNumber: this.questionData.displayNumber,

      // Content fields
      question: this.questionData.questionText,
      description: this.questionData.description,
      type: this.adaptType(this.questionData.type),
      required: this.questionData.required,
      accentColor: this.questionData.accentColor || '#ffffff',

      // Path and block info
      path: this.questionData.path,
      blockNumber: this.questionData.blockNumber
    };

    // Add type-specific properties
    switch (this.questionData.type) {
      case 'single-choice':
      case 'multi-choice':
      case 'boolean':
        adapted.options = this.adaptOptions();
        if (this.questionData.maxSelections) {
          adapted.maxSelections = this.questionData.maxSelections;
        }
        break;

      case 'scale':
        adapted.scale = this.questionData.scale || {
          min: 1,
          max: 5,
          labels: { 1: 'Very Poor', 5: 'Excellent' }
        };
        break;

      case 'open-short':
      case 'open-long':
        adapted.placeholder = this.questionData.placeholder || 'Type your answer here...';
        adapted.multiline = this.questionData.type === 'open-long' || this.questionData.multiline;
        break;
    }

    return adapted;
  }

  adaptType(questionType) {
    // Map QuestionData types to UI types that match styling
    const typeMap = {
      'single-choice': 'single-choice',
      'multi-choice': 'multi-choice',
      'scale': 'scale',
      'boolean': 'boolean',
      'open-short': 'open',
      'open-long': 'open'
    };

    return typeMap[questionType] || 'single-choice';
  }

  adaptOptions() {
    if (!this.questionData.options) return [];

    // QuestionData has options as simple strings array
    // Convert to { value, label } format expected by UI
    return this.questionData.options.map(option => ({
      value: option,
      label: option
    }));
  }
  
  // Static method to adapt a Question for UI consumption
  static adapt(question) {
    if (!question) return null;
    return new QuestionAdapter(question).toUIFormat();
  }
}